import type { MlsCandidateSnapshot } from "../types/mlsCandidate";

// MB-1430: a candidate whose MLS forbids it on the internet. It stays visible
// in the review list flagged with the reason, but it can never be imported -
// so it must not be counted as available to import, and must not be what
// keeps the setup wizard's listing step alive.
//
// A candidate whose MLS hides the ADDRESS is importable. The feed withholds
// the street (and the coordinates), so the listing is marketed as
// "City, ST ZIP" with no map pin; the row says so instead of refusing.
export const isImportBlocked = (
    snapshot: MlsCandidateSnapshot | undefined,
): boolean => snapshot?.internetDisplayBlocked === true;

// No RESO field names here: an agent does not know what
// InternetEntireListingDisplayYN is, and it reads as leaked internals.
// Support triage keys off the api log's `reason` field instead.
export const importBlockedTooltip = (): string =>
    "Your MLS has this listing marked as not displayable on the internet, so it can't be imported. Update the listing in the MLS to allow it to be displayed online.";

export const isAddressHidden = (
    snapshot: MlsCandidateSnapshot | undefined,
): boolean => snapshot?.addressUnavailable === true;

// "City, ST ZIP" from the parts the feed sent; the api fills the state from
// the row's county code when Trestle withholds it, so it is normally present.
export const hiddenAddressLabel = (
    snapshot: MlsCandidateSnapshot | undefined,
): string =>
    [
        snapshot?.PostalCity,
        [snapshot?.StateOrProvince, snapshot?.PostalCode]
            .filter(Boolean)
            .join(" "),
    ]
        .filter(Boolean)
        .join(", ");

export const addressHiddenTooltip = (
    snapshot: MlsCandidateSnapshot | undefined,
): string =>
    `Your MLS hides this listing's address. It will be marketed as ${
        hiddenAddressLabel(snapshot) || "its city and ZIP"
    }, with no street and no map pin, and published posts say "Undisclosed Address".`;
